import React, { memo } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { IconVerfied } from '@prisjakt/ui/icon';
import {
  IconAndTextWrapper,
  Logo,
  LogoWrapper,
  RecommendedRetailerExpansion,
  Text,
} from './styles';

type Props = {
  id: number;
  name: string;
  logo?: string | null;
  pathName: string;
};

export const RecommendedRetailer = memo((props: Props) => {
  const { name, logo, pathName, id } = props;
  const { linkTo, t } = useAppContext();

  return (
    <RecommendedRetailerExpansion>
      <IconAndTextWrapper>
        <IconVerfied color="base300" />
        <Text>
          {t('store', 'store.recommended-retailer-brand', { brand: name })}
        </Text>
      </IconAndTextWrapper>

      {logo ? (
        <LogoWrapper to={linkTo('brand', { pathName, id })}>
          <Logo src={logo} alt={name} />
        </LogoWrapper>
      ) : null}
    </RecommendedRetailerExpansion>
  );
});
